var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-flex",
        { staticClass: "sm12 md12 modal-capacitaciones__btn" },
        _vm._l(_vm.items, function(item) {
          return _c(
            "v-btn",
            {
              key: item.iditem,
              class: _vm.activeBtn === Number(item.iditem) && "btn--activate",
              on: {
                click: function($event) {
                  _vm.showModal({ item: Number(item.iditem) })
                }
              }
            },
            [_vm._v("\n      " + _vm._s(item.nombre) + "\n    ")]
          )
        }),
        1
      ),
      _vm.dialog && !_vm.loadingModal
        ? _c("div", { staticClass: "modal-options" }, [
            Object.keys(_vm.data).length > 0
              ? _c(
                  "section",
                  { staticClass: "sm12 md12" },
                  [
                    _c("CardsCategoria", {
                      attrs: { element: _vm.item, dataOption: _vm.data }
                    })
                  ],
                  1
                )
              : _c("section", [
                  _c("div", { staticClass: "seccion-vacia" }, [
                    _vm._v("Esta sección está vacía.")
                  ])
                ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }